module.exports = __webpack_public_path__ + "static/media/NG.9e50f6ae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/NG.svg
// module id = 328
// module chunks = 0